import { render } from "./Mancillado.vue?vue&type=template&id=d3b101e4"
import script from "./Mancillado.vue?vue&type=script&lang=js"
export * from "./Mancillado.vue?vue&type=script&lang=js"

import "./Mancillado.vue?vue&type=style&index=0&id=d3b101e4&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__